<template>
  <div class="form-area-coach" v-loading="submitLoading">
    <!-- 步骤条 -->
    <div class="steps-box">
      <div :class="['step',stepIndex === 1?'active':'']"><img :src="editSvg" /><span>1.Personal Information</span></div>
      <div :class="['step2',stepIndex === 2?'active':'']"><img :src="videoSvg" />2.Self Introduction</div>
    </div>
    <el-form ref="coachInfoForm" :model="coachInfoForm" label-position="top">
      <!-- 基础信息填写 -->
      <div v-if="stepIndex === 1">
        <!-- 姓名 -->
        <el-row :gutter="32">
          <el-col :span="12">
            <el-form-item label="1.First name" prop="first_name" :rules="[{ required: true, message: 'Please enter', trigger: 'blur' }]">
              <el-input placeholder="Please enter" v-model="coachInfoForm.first_name"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="2.Last name" prop="last_name" :rules="[{ required: true, message: 'Please enter', trigger: 'blur' }]">
              <el-input placeholder="Please enter" v-model="coachInfoForm.last_name"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
          <!-- title、website -->
          <el-row :gutter="32">
            <!-- <el-col :span="12">
              <el-form-item label="Title" prop="title" :rules="[{ required: true, message: 'Please enter', trigger: 'change' }]">
                <el-input v-model="coachInfoForm.title" placeholder="Please enter"></el-input>
              </el-form-item>
            </el-col> -->
            <el-col :span="12">
              <el-form-item label="Mobile" prop="mobile" :rules="[{ required: true, message: 'Please enter', trigger: 'blur' }]">
                <el-row :gutter="10">
                  <el-col :span="6">
                    <el-tooltip
                      :content="coachInfoForm.mobile_country_code+'('+nowPrefixName+')'"
                      placement="top-start">
                      <el-select filterable v-model="coachInfoForm.mobile_country_code" @change="changePrefixCode" placeholder="Select">
                        <el-option
                            v-for="(item, key) of phonePrefixCode"
                            :value="item.code"
                            :key="key"
                            :title="item.code+'('+item.en+')'"
                            :label="item.code+'('+item.en+')'"
                          >
                          {{ item.code+'('+item.en+')' }}
                        </el-option>
                      </el-select>
                    </el-tooltip>
                  </el-col>
                  <el-col :span="18">
                    <el-input v-model="coachInfoForm.mobile" placeholder="Please enter"></el-input>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <!-- :rules="[{ required: true, message: 'Please enter', trigger: 'change' }]" -->
              <el-form-item label="Website" prop="personal_website">
                <el-input v-model="coachInfoForm.personal_website" placeholder="Please enter"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- linkedin、twitter -->
          <el-row :gutter="32">
            <el-col :span="12">
              <el-form-item  label="Twitter">
                <el-input v-model="coachInfoForm.twitter" placeholder="Please enter"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Linkedin">
                <el-input v-model="coachInfoForm.linkedin" placeholder="Please enter"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- summary -->
          <el-row class="leapin-mb-12">
            <el-col :span="20">
              <el-form-item label="Summary" prop="description" :rules="[{ required: true, message: 'Please enter', trigger: 'change' }]">
                <el-input type="textarea" :rows="6" placeholder="Please enter" v-model="coachInfoForm.description"></el-input>
              </el-form-item>
            </el-col>
          </el-row>


          <!-- 分割线 -->

          <div class="item-title"><img :src="linkAir" />  Coaching information</div>
          <!-- type of coach -->
          <el-row>
            <el-col :span="20">
              <el-form-item label="Type of coach" prop="coach_type" :rules="[{ required: true, message: 'Please select', trigger: 'change' }]">
                <el-select class="leapin-w-100" multiple v-model="coachInfoForm.coach_type" placeholder="Please select">
                  <el-option 
                    v-for="(item,index) in coachCodeList"
                    :key="index"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- Years of coaching experience -->
          <el-row>
            <el-col :span="20">
              <el-form-item label="Years of coaching experience" prop="work_year" :rules="[{ required: true, message: 'Please enter', trigger: 'change' }]">
                <el-input type="number" v-model="coachInfoForm.work_year" placeholder="Please enter"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- Target audience -->
          <el-row>
            <el-col :span="20">
              <el-form-item label="Target audience" prop="target_audience" :rules="[{ required: true, message: 'Please select', trigger: 'change' }]">
                <el-select class="leapin-w-100" multiple v-model="coachInfoForm.target_audience" placeholder="Please select">
                  <el-option 
                    v-for="(item,index) in targetAudienceList"
                    :key="index"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- Specialities -->
          <el-row>
            <el-col :span="20">
              <el-form-item label="Specialities" prop="specialities" :rules="[{ required: true, message: 'Please select', trigger: 'change' }]">
                <el-select class="leapin-w-100" multiple v-model="coachInfoForm.specialities" placeholder="Please select">
                  <el-option 
                    v-for="(item,index) in specialtiesList"
                    :key="index"
                    :label="item"
                    :value="item">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- Languages -->
          <el-row>
            <el-col :span="20">
              <el-form-item label="Languages" prop="languages" :rules="[{ required: true, message: 'Please select', trigger: 'change' }]">
                <el-select class="leapin-w-100" multiple v-model="coachInfoForm.languages" placeholder="Please select">
                  <el-option
                    v-for="(item,index) in languagesCodeList"
                    :key="index"
                    :label="item.name"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- Work experience -->
          <el-row>
            <el-col :span="20">
              <el-form-item label="Work experience" prop="work_experience" :rules="[{ required: true, message: 'Please enter', trigger: 'change' }]">
                <el-input type="textarea" :rows="6" placeholder="Please enter" v-model="coachInfoForm.work_experience"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- Education -->
          <el-row>
            <el-col :span="20">
              <el-form-item label="Education" prop="education" :rules="[{ required: true, message: 'Please enter', trigger: 'change' }]">
                <el-input type="textarea" :rows="6" placeholder="Please enter" v-model="coachInfoForm.education"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- Credentials -->
          <el-row>
            <el-col :span="20">
              <el-form-item label="Credentials" prop="credentials" :rules="[{ required: true, message: 'Please enter', trigger: 'change' }]">
                <el-input placeholder="Please enter" @blur="handleEnter(credentialsInputValue,'credentials')" v-model="credentialsInputValue" @keyup.enter.native="handleEnter(credentialsInputValue,'credentials')"></el-input>
                <div class="tags leapin-mt-20">
                  <el-tag
                    v-for="(tag, index) in coachInfoForm.credentials"
                    :key="index"
                    closable
                    @close="handleClose(tag, coachInfoForm.credentials)">
                    {{ tag }}
                  </el-tag>
                </div>
              </el-form-item>
            </el-col>
          </el-row>

          <div class="item-title"><img :src="linkAir" />  Available Time</div>
          <!-- Select a Date & Time -->
          <el-row>
            <el-col :span="20">
              <el-form-item label="Select a Date & Time" prop="schedule" :rules="[{ required: true, message: 'Please select', trigger: 'change' }]">
                <div class="leapin-mb-12" v-for="(itemTime,index) in coachInfoForm.schedule" :key="index">
                  <el-date-picker
                    v-model="itemTime.start_time"
                    type="datetime"
                    placeholder="Select start time"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    format="yyyy-MM-dd HH:mm:ss"
                    class="leapin-w-100">
                  </el-date-picker>
                  <el-date-picker
                    v-model="itemTime.end_time"
                    type="datetime"
                    placeholder="Select end time"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    format="yyyy-MM-dd HH:mm:ss"
                    class="leapin-w-100 leapin-ml-16">
                  </el-date-picker>
                  <i v-if="index > 0" class="el-icon-remove-outline pointer leapin-ml-16" @click="deleteTime(index)"></i>
                </div>
              </el-form-item>
              <div class="leapin-tags leapin-mb-6 leapin-purple" @click="addMoreTime()"><i class="el-icon-plus"></i>Add Date</div>
            </el-col>
          </el-row>
          <!-- timezone -->
          <el-row>
            <el-col :span="20">
              <el-form-item label="Time zone" prop="timezone" :rules="[{ required: true, message: 'Please select', trigger: 'blur' }]">
                <el-select filterable v-model="coachInfoForm.timezone" class="leapin-mb-20">
                  <el-option
                    v-for="(item,index) in timeZoneList"
                    :key="index"
                    :value="item">
                    {{ item }}
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <!-- Charging Rate -->
          <el-row>
              <el-form-item label="Charging Rate" prop="charge_currency" :rules="[{ required: true, message: 'Please select', trigger: 'blur' }]">
                <el-col :span="4">
                  <el-select filterable v-model="coachInfoForm.charge_currency" class="leapin-mb-20">
                    <el-option label="USD" value="USD"></el-option>
                    <el-option label="EUR" value="EUR"></el-option>
                    <el-option label="CNY" value="CNY"></el-option>
                    <el-option label="SGD" value="SGD"></el-option>
                  </el-select>
                </el-col>
                <el-col :span="4">
                  <el-form-item prop="charge_rate" :rules="[{ required: true, message: 'Please enter', trigger: 'blur' }]">
                    <el-input v-model="coachInfoForm.charge_rate" placeholder="Please enter"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="2"><span>&nbsp;&nbsp;/ hour</span></el-col>
              </el-form-item>
          </el-row>
          <!-- How many free trail session are you offering? -->
          <el-row>
            <el-col :span="6">
              <el-form-item label="How many free trail session are you offering?" prop="free_trial_count" :rules="[{ required: true, message: 'Please enter', trigger: 'change' }]">
                <el-input type="number" v-model="coachInfoForm.free_trial_count" placeholder="Please enter"></el-input>
              </el-form-item>
            </el-col>
          </el-row>


      </div>
      <!-- 视频录制 -->
      <div v-if="stepIndex === 2">
        <div class="web-video-answer" ref="affixWraper">
          <div class="web-video-answer-content">
            <div class="web-video-answer-box">
              <img src="@/assets/images/img_person.png" class="left" />
              <div class="right">
                <!-- 回答问题视频窗口 -->
                <div v-show="isStart || haveInroduceVideo" ref="videoAnswerPlayerWrap" class="video-window">
                  <div
                    v-if="!haveInroduceVideo"
                    :class="[
                      'leapin-w-100',
                      'leapin-h-100',
                      'leapin-bg-black',
                      'local-player-cls',
                    ]">
                    <div id="local-player" class="leapin-h-100"></div>
                  </div>
                  <video
                     v-else
                     controls
                     :src="coachInfoForm.introduce_video_url"
                     type="video/mp4"
                     class="leapin-w-100 leapin-h-100 local-player-cls"
                     >
                  </video>
                </div>
                <div class="bottom" :class="[isStart? 'leapin-fs-14' : 'leapin-fs-18']">
                  Please use video to introduce yourself. 
                </div>
                <!-- 按钮 -->
                <!-- 开始回答 -->
                <el-button
                  @click="handleStart"
                  class="ans-button"
                  type="primary"
                  v-if="!isStart"
                  :loading="loading"
                  style="width: 100%;"
                  round>
                 {{ haveInroduceVideo == false ? 'Start': 'Re record' }}
                </el-button>
                <!-- 完成回答 -->
                <el-button
                  @click="handleFinish"
                  :disabled="!isCanFinish"
                  type="primary"
                  class="ans-button"
                  v-else
                  style="width: 100%;"
                  round>
                  End
                </el-button>
                <el-row v-if="!isStart && haveInroduceVideo == false" class="ans-skip">
                  <el-button @click="submitDisabled = false" type="text">Skip</el-button>
                </el-row>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 按钮操作 -->
      <el-row :gutter="20">
        <div class="form-line">
          <el-col v-show="stepIndex === 1" :span="12" class="leapin-text-right">
            <el-button :loading="saveLoading" round @click="saveInfo()">Save</el-button>
          </el-col>
          <el-col v-show="stepIndex === 1" :span="12">
            <el-button type="primary" round @click="nextStep()">Next</el-button>
          </el-col>

          <el-col v-show="stepIndex === 2" :span="12" class="leapin-text-right">
            <el-button :disabled="backDisabled" round @click="upStep()">Back</el-button>
          </el-col>
          <el-col :span="12" v-show="stepIndex === 2">
            <el-button key="submitKey" type="primary" :disabled="submitDisabled" round @click="submitInfo()">Submit</el-button>
          </el-col>
        </div>
      </el-row>
    </el-form>

    
  </div>
</template>

<script>
import { addressList } from "@/services/address.js";
import newPhonePrefixCode from "@/constants/newPhonePrefixCode";
import {
  getAgoraChannelInfo,
  agoraRecordingStart,
  agoraRecordingStop,
  agoraRecordingSids,
} from "@/services/agora";
import { sendUserInfo, getUserInfo } from "@/services/user";
import { createAgoraPublish, handleAgoraChanelLeave } from "@/utils/agora";
import { COACH_CODE }  from '@/constants/coachCode'
import { TARGET_AUDIENCE_CODE } from '@/constants/targetAudience'
import { LANGUAGE_CODE } from '@/constants/languages'
import { TIMEZONE_CODE } from '@/constants/timeZone'
import request from "@/utils/request";
export default {
  name: 'coachInfoForm',
  props: {
    editType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      submitDisabled: true,
      phonePrefixCode: newPhonePrefixCode,
      nowPrefixName: 'China',
      backDisabled: false,
      saveLoading: false,
      timeZoneList: TIMEZONE_CODE,
      credentialsInputValue: '',
      languagesCodeList: LANGUAGE_CODE,
      targetAudienceList: TARGET_AUDIENCE_CODE,
      coachCodeList: COACH_CODE,
      linkAir: require('@/assets/svgs/link-air.svg'),
      cvUploading: false,
      editSvg: require('@/assets/svgs/edit-form.svg'),
      videoSvg: require('@/assets/svgs/video-form.svg'),
      //视频录制相关字段--start
      haveInroduceVideo: false,
      isStartFinishCountdown: false,
      isStart: false,
      isCanFinish: false,
      agoraStatusQuery: null,
      loading: false,
      agoraSid: null,
      videoEleW: null,
      videoEleH: null,
      videoEle: null,
      //视频录制相关字段--end
      uploadSvg: require('@/assets/images/users/upload.png'),
      stepIndex: 1,
      hobbiesInputValue: '',
      intentionInputValue: '',
      challengesInputValue: '',
      specialtiesList: [
        'Career coaching',
        'Personal development planning',
        'Startup advice',
        'Mental health advice',
        'Exam prep',
        'Resume craving',
        'Interview coaching',
        'Professional upskilling',
        'Life coaching',
        'Performance coaching',
        'Relationship coaching',
        'Sales coaching',
        'Employee coaching',
        'Success coaching',
        'Transformational coaching',
        'Wellness coaching',
        'Executive coaching',
        'Leadership coaching',
        'Financial coaching',
        'Spiritual coaching',
      ],

      locationList: [], //地址列表 用户自己保存过的 从后台获取
      submitLoading: false,
      coachInfoForm: {
        first_name: '',
        last_name: '',
        mobile: '',
        mobile_country_code: '86',
        // avatar: '',
        introduce_video_url: "", //# 录制完视频后调用的sids接口返回的signed_url
        title: '', // # string 头衔
        personal_website: '', // # string 个人网站
        linkedin: '', // # string linkedin
        twitter: '', // # string twitter
        description: '', // # string 简介
        coach_type: [], // # int 教练类型 0-19 参考文档对应字段上下顺序
        work_year: '', // # int 教练经验 
        target_audience: [], // # int 目标受众 0-11 参考文档对应字段上下顺序
        languages: [], // # list 语言
        work_experience: '', // # string 工作经验
        education: '', // # string 教育经历
        specialities: [], // # list 专业领域 参考文档specialities字段
        credentials: [], // # list 证书
        schedule: [
          {
            start_time: '', // # string 开始时间
            end_time: '', // # string 结束时间
          }
        ], // # list 时间排期
        timezone: undefined, // # string 时区
        charge_rate: '', // # string 价格
        charge_currency: '', // # string 货币
        free_trial_count: 0, // # int 免费提供的次数

      },
      intention_addressList: [],
      file: null,
      fileName: ''
    }
  },
  mounted () {
    this.getAddressList()
    this.getReportInfo()
  },
  methods: {
    changePrefixCode (val) {
      this.nowPrefixName = this.phonePrefixCode.filter(item => item.code === val)[0].en
    },
    upStep() {
      if (this.backDisabled) {
        return
      }
      this.stepIndex = 1
    },
    saveInfo() {
      delete this.coachInfoForm.id
      this.coachInfoForm.is_completed = false
      this.saveLoading = true
      sendUserInfo(this.coachInfoForm).then(res => {
        if (res.code === 0) {
          this.saveLoading = false
          this.$message({
            message: 'Save successfully',
            type: 'success'
          });
        } else {
          this.saveLoading = false
          this.$message({
            message: 'Submit failed',
            type: 'error'
          });
        }
      }).catch(error => {
        this.saveLoading = false
        console.error('Submit error', error);
      });
    },
    //删除时间
    deleteTime(index) {
      this.coachInfoForm.schedule.splice(index, 1)
    },
    //添加时间
    addMoreTime() {
      this.coachInfoForm.schedule.push({
        start_time: '',
        end_time: ''
      })
    },
    //获取登陆人信息
    getReportInfo() {
      getUserInfo({}).then((res) => {
        if (res.code === 0) {
          this.coachInfoForm = {...this.coachInfoForm, ...res.data.extra_info}
          if (this.coachInfoForm.schedule == null) {
            this.coachInfoForm.schedule = []
            this.coachInfoForm.schedule.push({
              start_time: '',
              end_time: ''
            })
          }
          this.coachInfoForm.first_name = res.data.first_name
          this.coachInfoForm.last_name = res.data.last_name
          this.coachInfoForm.mobile = res.data.mobile
          this.coachInfoForm.mobile_country_code = res.data.mobile_country_code
          this.coachInfoForm.coach_type = this.coachInfoForm.coach_type.map(item => parseInt(item))
          this.coachInfoForm.target_audience = this.coachInfoForm.target_audience.map(item => parseInt(item))
          console.log('this.coachInfoForm', JSON.stringify(this.coachInfoForm));
          this.haveInroduceVideo = this.coachInfoForm.introduce_video_url != '' ? true : false;
          //this.intention_addressList = this.coachInfoForm.intention_address.split('/')
          //this.fileName = this.coachInfoForm.cv_url.split('/').pop()
          this.isStart = false;
        } else {
          this.$message.error(res.message);
        }
      })
    },
    handleChange(value) {
      this.coachInfoForm.intention_address = value.join('/');
    },
    nextStep() {
      this.$refs.coachInfoForm.validate((valid) => {
        if (valid) {
          //console.log('coachInfoForm', JSON.stringify(this.coachInfoForm));
          this.saveInfo()
          this.stepIndex = 2
        } else {
          this.$emit('scrollToTop')
          return false;
        }
      });
    },
    // 视频录制--相关方法--start
    handleStart() {
      this.loading = true;
      this.haveInroduceVideo = false;
      this.backDisabled = true;
      getAgoraChannelInfo().then((res) => {
          if (res.code === 0) {
            createAgoraPublish(
              res.data.app_id,
              res.data.channel,
              res.data.token,
              res.data.uid,
              "local-player",
              () => {
                agoraRecordingStart({is_vertical: false,}).then((res) => {
                    this.loading = false;
                    this.isStart = true;
                    if (res) {
                      this.isStartFinishCountdown = true;
                      this.agoraSid = res.data.s_id;
                    }
                  }).catch(() => {
                    this.handleAgoraRecordingReset();
                  });
              },() => {
                
              }
            );
          } else {
            this.loading = false;
            
          }
        })
        .catch(() => {
          this.loading = false;
          
        });
    },
    // 完成录制
    handleFinish() {
      //this.$refs.countdownFinishRef.pause();
      this.loading = true;
      this.stopTimer = setTimeout(() => {
        agoraRecordingStop({
          s_id: this.agoraSid,
        }).then((res) => {
            this.loading = false;
            this.backDisabled = false;
            if (res) {
              handleAgoraChanelLeave("local-player");
              this.agoraSid = res.data.s_id;
              agoraRecordingSids({
                s_ids: [this.agoraSid],
              }).then((res) => {
                  this.loading = false;
                  if (res && res.data && res.data[0]) {
                    console.warn('录制结果为='+res.data[0].signed_url);
                    this.coachInfoForm.introduce_video_url = res.data[0].signed_url;
                    this.haveInroduceVideo = true;
                    this.isStart = false;
                    this.submitDisabled = false;
                  } else {
                    this.handleAgoraRecordingReset();
                  }
                })
                .catch(() => {
                  this.loading = false;
                  this.handleAgoraRecordingReset();
                });
            } else {
              this.backDisabled = false;
              this.loading = false;
              this.handleAgoraRecordingReset();
            }
          })
          .catch(() => {
            this.backDisabled = false;
            this.loading = false;
            this.handleAgoraRecordingReset();
          });
      }, 1000);
    },
    // 开始录制--end




    handleEnter(value,list) {
      if (value.trim()) {
        if (list === 'credentials') {
          this.coachInfoForm.credentials.push(value.trim());
          this.credentialsInputValue = '';
        }
      }
    },
    handleClose(tag, list) {
      const index = list.indexOf(tag);
      if (index !== -1) {
        list.splice(index, 1); // 从标签数组中移除标签
      }
    },
    // 获取地址列表
    getAddressList() {
      addressList({page:1,page_size:100}).then(res => {
        this.locationList = res.data.results
      })
    },
    handleFileUpload(event) {
      this.file = event.target.files[0];
      this.fileName = this.file.name;
      console.log('文件', this.file);
      this.cvUploading = true;
      let formData = new FormData();
      formData.append('cv_file', this.file);
      request({
        url: '/users/me/upload/cv/',
        method: "post",
        data: formData,
      }).then((res) => {
        if (res) {
          this.cvUploading = false;
          this.coachInfoForm.cv_url = res.data.cv_url;
        }
      }).catch(error => {
        console.error('文件上传失败', error);
      });
    },

    // 提交表单
    submitInfo() {
      this.submitLoading = true
      delete this.coachInfoForm.id
      this.coachInfoForm.is_completed = true
      sendUserInfo(this.coachInfoForm).then(res => {
        if (res.code === 0) {
          this.submitLoading = false
          this.$message({
            message: 'Submit successfully',
            type: 'success'
          });
          if (this.editType === 1) { //表示是修改页面
            this.$emit('updateInfo') 
          } else {
            //获取登陆人信息后进行跳转
            getUserInfo({}).then((res) => {
              if (res.code === 0) {
                this.$store.dispatch("user:userinfo", res.data);
                this.$router.push({ path: '/CoachShow' })
              }
            })
          }
        } else {
          this.submitLoading = false
          this.$message({
            message: 'Submit failed',
            type: 'error'
          });
        }
      }).catch(error => {
        this.submitLoading = false
        console.error('Submit error', error);
      });
    }



  }
}
</script>
<style scoped lang="scss">
.form-area-coach {
  margin-top: 20px;
  padding: 32px 52px 64px 52px;
  border-radius: 32px;
  background: #FFF;
  .steps-box {
    padding: 0 20%;
    margin-bottom: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #FFF;
    text-align: center;
    font-family: Inter;
    font-size: 12px;
    font-weight: 400;
    .step {
      width: 150px;
      display: flex;
      padding: 12px 16px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-radius: 8px 0px 0px 8px;
      background: #C5C0F5;
    }
    .step2 {
      width: 140px;
      display: flex;
      width: 168px;
      padding: 12px 8px;
      justify-content: center;
      align-items: center;
      gap: 10px;
      border-radius: 0px 8px 8px 0px;
      background: #C5C0F5;
    }
    .active { background: #6E62E5 !important; }
  }
  .form-line {
    border-top: 2px solid #E6E8F0;
    padding-top: 32px;
  }
  .tags {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-start;
    gap: 5px;
  }
  .el-tag {
    border-radius: 1px !important;
    background: rgba(110, 98, 229, 0.15) !important;
    color: #6E62E5 !important;
    border: 1px solid rgba(110, 98, 229, 0.15) !important;
  }
  .upload-box {
    width: 260px;
    height: 145px;
    border-radius: 6px;
    position: relative;
    img {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 1;
      width: 260px;
      height: 145px;
      object-fit: contain;
    }
    input {
      width: 100%;
      height: 100%;
      opacity: 0;
      cursor: pointer;
      position: relative;
      z-index: 2;
    }
  }
  .item-title {
    color: #000;
    font-size: 16px;
    font-weight: 600;
    margin-bottom: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    letter-spacing: 0.5px;
    border-top: 1px solid #E6E8F0;
    padding-top: 32px;
    img {
      width: 18px;
      height: 18px;
      margin-right: 8px;
    }
  }

  .web-video-answer {
    background: rgba(0, 0, 0, .04);
    display: flex;
    justify-content: center;
    align-items: center;
    .web-video-answer-content {
      width: 800px;
      box-shadow: 0 4px 16px 0 #d9d9d9;
      margin: 40px auto 40px;
      .web-video-answer-box {
        padding: 0px 40px;
        min-height: 583px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 0 40px;
        .left {
          width: 320px;
          height: 483px;
          object-fit: cover;
        }
        .right {
          flex: 1;
          height: 487px;
          position: relative;
          .top {
            font-weight: 600;
            color: #000;
            .clock {
              float: right;
              img {
                width: 15px;
                height: auto;
                margin-right: 5px;
              }
            }
          }
          .bottom {
            font-weight: 600;
            margin: 10px 0;
            color: #000;
          }
          .video-window {
            width: 360px;
            height: 280px;
            margin-bottom: 20px;
          }
          .down-time {
            font-size: 14px;
          }
        }
        .ans-button {
          width: 200px;
          border-radius: 3px;
          font-size: 18px;
          position: absolute;
          bottom: 0px;
          right: 0px;
          background: linear-gradient(to right, #2257bf, #2257bf);
          color: #fff;
        }
        .ans-skip {
          width: 100%;
          position: absolute;
          bottom: -40px;
          right: 0px;
          text-align: center;
        }
      }
    }
  }
}
</style>
